
// You can write more code here

/* START OF COMPILED CODE */

import TrapImageBase from "../TrapImageBase";
/* START-USER-IMPORTS */
/* END-USER-IMPORTS */

export default class TrapImage extends TrapImageBase {

  constructor(scene: Phaser.Scene, x?: number, y?: number, texture?: string, frame?: number | string) {
    super(scene, x ?? 27.5, y ?? 24, texture || "game", frame ?? "icon-grizz.png");

    /* START-USER-CTR-CODE */
    // Write your code here.
    /* END-USER-CTR-CODE */
  }

  public zIndex: number = 0;

  /* START-USER-CODE */

  // Write your code here.

  /* END-USER-CODE */
}

/* END OF COMPILED CODE */

// You can write more code here
